import { InputAddressData } from '@afterpaytouch/core'
import { Validate } from 'react-hook-form'
import { isConsumerLendingEligibleState } from '../../utils/profile-validation'

export const validateIneligibleStates = (message: string): Record<string, Validate<InputAddressData, any>> => {
  return {
    ineligibleState: (address, _) => {
      return isConsumerLendingEligibleState(address) || message
    },
  }
}
